import { atom, createStore } from 'jotai';
import { Account } from '@dodilio/ui-auth-lib/dist/types/account';
import { CreateAccountCore } from './types/register';

export const accountAtom = atom<Account>();
export const tokenAtom = atom<string>();
export const createAccountAtom = atom<CreateAccountCore>();
export const iamStore = createStore();
